import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

function SEO({ description, lang, meta, title, slug }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  );

  const metaDescription = description || site.siteMetadata.description;
  const combinedTitle = title ? title + " | " + site.siteMetadata.title : site.siteMetadata.title;

  // Check if the slug contains '-test-' and adjust meta tags accordingly
  const testSlugs = ["-test", "test-"];

  const isTestPage = slug && testSlugs.some((testSlug) => slug.includes(testSlug));
  const robotsMeta = isTestPage ? <meta key="robots" name="robots" content="noindex, nofollow" /> : null;

  return (
    <>
      <html lang={lang} />
      <title>{combinedTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content={site.siteMetadata.author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      {meta.map((m, index) => (
        <meta key={index + "-meta-index"} name={m.name} content={m.content} property={m.property} />
      ))}
      {robotsMeta}

      <script>
        {`(function(win, doc, style, timeout) {
              var STYLE_ID = "at-body-style";

              function getParent() {
                return doc.getElementsByTagName("head")[0];
              }

              function addStyle(parent, id, def) {
                if (!parent) {
                  return;
                }
                var style = doc.createElement("style");
                style.id = id;
                style.innerHTML = def;
                parent.appendChild(style);
              }

              function removeStyle(parent, id) {
                if (!parent) {
                  return;
                }
                var style = doc.getElementById(id);
                if (!style) {
                  return;
                }
                parent.removeChild(style);
              }

              addStyle(getParent(), STYLE_ID, style);
              setTimeout(function() {
                removeStyle(getParent(), STYLE_ID);
              }, timeout);
            })(window, document, "body {opacity: 0 !important}", 500)`}
      </script>

      <script>{`!function(s,a,e,v,n,t,z){if(s.saq)return;n=s.saq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!s._saq)s._saq=n;n.push=n;n.loaded=!0;n.version='1.0';n.queue=[];t=a.createElement(e);t.async=!0;t.src=v;z=a.getElementsByTagName(e)[0];z.parentNode.insertBefore(t,z)}(window,document,'script','https://tags.srv.stackadapt.com/events.js');saq('ts','TaWdGbbDCRHxYc9j2ibnmw');`}</script>

      {/* <script type="text/javascript" src="https://www.bugherd.com/sidebarv2.js?apikey=i2b6rof2gsjorw2lyzxicq" async={true}></script> */}

      <script src={process.env.GATSBY_LAUNCH_URL} async={true}></script>
    </>
  );
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
};

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default SEO;
